export default [
    {
        "id": "categoryDescription-1",
        "plugin": null,
        "pluginId": null,
        "name": null,
        "html": require('./categoryDescriptions/categoryDescription-1/html').default,
        "config": `{}`,
        "showOptions": true,
        "settingsBeforeList": `{"nameGraphDescCategory":"up"}`,
        "settingsAfterList": `{"nameGraphDescCategory":"down"}`,
        "svgContent": require('./categoryDescriptions/categoryDescription-1/svgContent').default,
        "svgViewBox": "0 0 1440 360",
        "svgContentMobile": require('./categoryDescriptions/categoryDescription-1/svgContentMobile').default,
        "svgViewBoxMobile": "0 0 360 360"
    },
    // {
    //     "id": "categoryDescription-2",
    //     "plugin": null,
    //     "pluginId": null,
    //     "name": null,
    //     "html": require('./categoryDescriptions/categoryDescription-2/html').default,
    //     "css": require('./categoryDescriptions/categoryDescription-2/css').default,
    //     "cssTablet": require('./categoryDescriptions/categoryDescription-2/cssTablet').default,
    //     "cssMobile": require('./categoryDescriptions/categoryDescription-2/cssMobile').default,
    //     "scss": require('./categoryDescriptions/categoryDescription-2/scss').default,
    //     "scssTablet": require('./categoryDescriptions/categoryDescription-2/scssTablet').default,
    //     "scssMobile": require('./categoryDescriptions/categoryDescription-2/scssMobile').default,
    //     "config": `{}`,
    //     "showOptions": true,
    //     "settings": `{"graphFormOfNameDescImgCategory":"background"}`,
    //     "settingsBeforeList": `{"nameGraphDescCategory":"up"}`,
    //     "settingsAfterList": `{"nameGraphDescCategory":"down"}`,
    //     "svgContent": require('./categoryDescriptions/categoryDescription-2/svgContent').default,
    //     "svgViewBox": "-19 -20 1083 246",
    //     "svgContentMobile": require('./categoryDescriptions/categoryDescription-2/svgContentMobile').default,
    //     "svgViewBoxMobile": "0 0 329 124"
    // }
]